const setUserInfo = (userInfo) => ({
    type: 'USER_INFO_SET',
    payload: userInfo,
});

export default setUserInfo;